/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  Box,
  useMediaQuery,
} from '@mui/material';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {
  Calendar as BigCalendar,
  momentLocalizer,
  Views,
} from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
// import {
//   addScheduleException,
//   updateSchedule,
// } from '../../../../redux/schedule/actions';
// getScheduleExceptionScheduleReplacementObject,
import { setPlannerCalendarView } from '../../../../redux/planner/actions';
import { eventStyleHandler } from '../../../../utils/scheduleHelper';
import theme from '../../../../utils/theme';
import Event from './components/Event';
import EventAgenda from './components/EventAgenda';
import CustomToolbar from './components/Toolbar';

const localizer = momentLocalizer(moment);
const DragAndDropCalendar = withDragAndDrop(BigCalendar);

const CalendarComponent = ({
  handleEventClick,
  setSelectedSlot,
  setStartDate,
  setEndDate,
  setOpenQuickSelectMenu,
  defaultCalendarView,
  startDate,
  endDate,
}) => {
  const lgDown = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch();

  // React State
  const [calendarView, setCalendarView] = React.useState(Views.WEEK);
  // const [snackbarState, setSnackbarState] = React.useState({
  //   open: false,
  //   message: '',
  //   severity: 'success',
  // });

  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  const events = useSelector((state) => state.board.events);
  const plannerCalendarView = useSelector((state) => state.planner.calendarView);

  const horseTagTypeId = (selectedBarn.barnMetadata && selectedBarn.barnMetadata.horseTagTypeId) || 0;
  // const isLoading = isFetchingBoard;

  React.useEffect(() => {
    if (defaultCalendarView === 'month' && !plannerCalendarView) {
      setCalendarView(Views.MONTH)
      dispatch(setPlannerCalendarView(Views.MONTH));
    } else if (plannerCalendarView === Views.MONTH) {
      setCalendarView(Views.MONTH)
    } else if (plannerCalendarView === Views.DAY) {
      setCalendarView(Views.DAY)
    } else if (plannerCalendarView === Views.AGENDA) {
      setCalendarView(Views.AGENDA)
    } else if (plannerCalendarView === Views.WEEK) {
      setCalendarView(Views.WEEK)
    } else {
      const fallbackView = lgDown
        ? Views.DAY
        : Views.WEEK;
      setCalendarView(fallbackView);
      dispatch(setPlannerCalendarView(fallbackView));
    }
  }, [defaultCalendarView, dispatch, lgDown, plannerCalendarView])

  const handleRangeChange = (e) => {
    if (e.start && e.end) {
      setStartDate(moment(e.start).startOf('day').toDate());
      setEndDate(moment(e.end).endOf('day').toDate());
    } else if (e.length === 1) {
      setStartDate(moment(e[0]).startOf('day').toDate());
      setEndDate(moment(e[0]).endOf('day').toDate());
    } else if (e.length === 7) {
      setStartDate(moment(e[0]).startOf('day').toDate());
      setEndDate(moment(e[6]).endOf('day').toDate());
    }
  };

  // const showSnackbar = React.useCallback((message, severity = 'success') => {
  //   setSnackbarState({
  //     open: true,
  //     message,
  //     severity,
  //   });
  // }, []);

  // const handleSnackbarClose = React.useCallback(() => {
  //   setSnackbarState((prev) => ({
  //     ...prev,
  //     open: false,
  //   }));
  // }, []);

  const { components } = React.useMemo(
    () => ({
      components: {
        agenda: { event: EventAgenda },
        event: Event,
        toolbar: CustomToolbar,
      },
    }),
    [],
  );
  const calendarDate = React.useMemo(() => {
    if (!startDate) {
      return moment(new Date()).toDate();
    }
    if (!endDate) {
      return moment(startDate).toDate();
    }
    if (calendarView === Views.DAY) {
      const todayMoment = moment().startOf('day');
      const startMoment = moment(startDate).startOf('day');
      const endMoment = moment(endDate).endOf('day');
      return (todayMoment.isBetween(startMoment, endMoment, 'day', '[]')
        ? todayMoment
        : startMoment).toDate();
    }
    return moment(startDate).add(moment(endDate).diff(moment(startDate)) / 2, 'milliseconds').toDate();
  }, [calendarView, endDate, startDate]);

  /*
    Consider:
    - Is the event in the past? event.inPast
    - Is the event part of a series?
    - Is the event already a schedule exception?

  */
  // const updateScheduleTiming = React.useCallback((event, start, end) => {
  //   console.log(event)
  //   if (!event?.resource?.id) {
  //     console.log('NO DATA RETURNING')
  //     return;
  //   }

  //   const isInPast = event.resource && !event.resource.inPast
  //     && new Date(event.resource.startDate).getTime() === new Date(event.resource.endDate).getTime()
  //   console.log('isInPast', isInPast)
  //   const isSingleOccurrence = event.resource && !event.resource.parentSchedule && event.resource.endDate
  //     && new Date(event.resource.startDate).getTime() === new Date(event.resource.endDate).getTime()
  //   console.log('isSingleOccurrence', isSingleOccurrence)
  //   const isScheduleException = event.resource
  //     && event.resource.parentSchedule && event.resource.parentSchedule.id;
  //   console.log('isScheduleException', isScheduleException)
  //   const hasMultipleTasksOrWorkflows = event.resource
  //     && (event.resource.workflows > 1);
  //   console.log('hasMultipleTasksOrWorkflows', hasMultipleTasksOrWorkflows)

  //   const durationMs = Math.max(end.getTime() - start.getTime(), 0);
  //   const payload = {
  //     startDate: start,
  //     duration: durationMs || event.resource.duration || 0,
  //   };

  //   if (isSingleOccurrence || isScheduleException) {
  //     // We can directly update the schedule
  //     dispatch(updateSchedule(event.resource.id, payload)).then(() => {
  //       showSnackbar('Updated successfully', 'success');
  //     }).catch((error) => {
  //       console.error(error);
  //       showSnackbar(error?.message || 'There was an error. Please try again or contact Questri Support.', 'error');
  //     });
  //   } else if (!isSingleOccurrence && !isScheduleException) {
  //     // Modifying an occurence in a series, so we need to add an exception
  //     dispatch(addScheduleException(event.resource.id, {
  //       exceptionDate: new Date(event.start),
  //       reason: 'Rescheduled occurrence',
  //       exceptionSchedule: {
  //         ...getScheduleExceptionScheduleReplacementObject(start, event.resource),
  //         duration: durationMs || event.resource.duration || 0,
  //       },
  //     })).then(() => {
  //       showSnackbar('Updated successfully', 'success');
  //     }).catch((error) => {
  //       console.error(error);
  //       showSnackbar(error?.message || 'There was an error. Please try again or contact Questri Support.', 'error');
  //     });
  //   }
  // }, [dispatch]);

  // const handleEventMove = React.useCallback(({
  //   event,
  //   start,
  //   end,
  // }) => {
  //   updateScheduleTiming(event, start, end);
  // }, [updateScheduleTiming]);

  // const handleEventResize = React.useCallback(({
  //   event,
  //   start,
  //   end,
  // }) => {
  //   updateScheduleTiming(event, start, end);
  // }, [updateScheduleTiming]);

  return (
    <Box
      sx={{
        px: 2,
        pt: 2,
      }}
    >
      <DragAndDropCalendar
        resizable
        // onEventDrop={handleEventMove}
        // onEventResize={handleEventResize}
        draggableAccessor={() => true}
        components={components}
        localizer={localizer}
        view={calendarView}
        onView={(newView) => {
          dispatch(setPlannerCalendarView(newView));
          setCalendarView(newView);
        }}
        onNavigate={() => {}}
        eventPropGetter={eventStyleHandler}
        dayLayoutAlgorithm="no-overlap"
        step={15}
        onRangeChange={handleRangeChange}
        onKeyPressEvent={handleEventClick}
        onSelectEvent={handleEventClick}
        onDoubleClickEvent={handleEventClick}
        selectable
        onSelectSlot={(slot) => { setOpenQuickSelectMenu(true); setSelectedSlot(slot); }}
        events={
          events.map((e) => ({
            ...e,
            view: calendarView,
            horseTags: e.resource.tags.filter((et) => et.tagType.id === horseTagTypeId),
          }))
        }
        startAccessor="start"
        endAccessor="end"
        style={{ height: 'calc(100vh - 200px)' }}
        scrollToTime={
          moment().add(-2, 'hours').toDate()
        }
        // defaultDate={Views.DAY !== calendarView && moment(new Date()).startOf('day').toDate()}
        date={calendarDate}
      />
      {/* <Snackbar
        open={snackbarState.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarState.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbarState.message}
        </Alert>
      </Snackbar> */}
    </Box>
  );
};

CalendarComponent.propTypes = {
  handleEventClick: PropTypes.func.isRequired,
  setSelectedSlot: PropTypes.func.isRequired,
  setStartDate: PropTypes.func.isRequired,
  setEndDate: PropTypes.func.isRequired,
  setOpenQuickSelectMenu: PropTypes.func.isRequired,
  defaultCalendarView: PropTypes.string,
  startDate: PropTypes.any,
  endDate: PropTypes.any,
};

CalendarComponent.defaultProps = {
  defaultCalendarView: null,
  startDate: null,
  endDate: null,
};

export default (CalendarComponent);
